module.exports = __webpack_public_path__ + "media/images/balance-prosperity-revenues-e6fa5a798f30a2e3e64e8ba768fc585b.png";